module.exports = __webpack_public_path__ + "static/media/plus.23dc414e.svg";